<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="110px" size="mini">
          <el-form-item label="经销商名称" prop="cusName">
            <el-input class="form-input" v-model="searchForm.cusName" clearable></el-input>
          </el-form-item>
          <el-form-item label="经销商状态" prop="cusStatus">
            <el-select v-model="searchForm.cusStatus" clearable @change="onSearch">
              <el-option v-for="item in cusStatusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="钱包类型" prop="type">
            <el-select v-model="searchForm.type" clearable @change="onSearch">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="核对时间" prop="updatedTime">
            <q-date-picker v-model="searchForm" ref="dateRef" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="goReturn">经销商核对记录</el-button>
        <el-button type="primary" size="small" @click="exportList">导出</el-button>
      </template>
      <el-table stripe v-loading="loading" ref="tableRef" highlight-current-row :data="tableData" border :height="maxTableHeight">
        <el-table-column prop="id" label="序号" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="cusName" label="经销商名称" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="cusStatus" label="经销商状态" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ cusStatusText[row.cusStatus] || "" }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="钱包类型" show-overflow-tooltip align="center">
          <template slot-scope="{ row }">
            {{ typeText[row.type] || "" }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="数据核对时间" align="center" show-overflow-tooltip width="160"></el-table-column>
        <el-table-column prop="customerName" label="核对周期" align="center" show-overflow-tooltip width="300">
          <template slot-scope="{ row }">
            {{ row.startTime ? row.startTime + " - " + row.endTime : "" }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="核对结果" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span :style="`${row.status == 0 ? 'color: red' : ''}`">{{ row.statusString }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="异常内容" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="160" class-name="action-column" align="center">
          <template v-slot="scope">
            <el-button type="text" size="small" style="color: red" @click="Reconciliation(scope.row, 1)" v-if="scope.row.status == 0"> 无需处理 </el-button>
            <el-button type="text" size="small" @click="Reconciliation(scope.row, 2)" v-if="scope.row.status == 0"> 重新对账 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [tableMixin,pagePathMixin],
  components: {},
  data() {
    return {
      searchForm: {
        cusName: "",
        activityId: "",
        cusStatus: "",
        type: "",
        reconciliationId: "",
        startTime: '',
        endTime: '',
      },
      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      cusStatusList: [
        { value: "", label: "全部" },
        { value: "1", label: "正常营业" },
        { value: "2", label: "预停业" },
        { value: "3", label: "已停业" },
        { value: "4", label: "预营业" },
        { value: "5", label: "未开业停用" },
        { value: "6", label: "经营异常" },
      ],
      typeList: [
        { value: "", label: "全部" },
        { value: "1", label: "老钱包" },
        { value: "2", label: "新钱包" },
      ],
      isCheckPhone: false,
      phone: "",
      typeText: {
        1: "老钱包",
        2: "新钱包",
      },
      statusText: {
        0: "活动异常",
        1: "异常后恢复为正常",
        2: "无需处理",
      },
      cusStatusText: {
        1: "正常营业",
        2: "预停业",
        3: "已停业",
        4: "预营业",
        5: "未开业停用",
        6: "经营异常",
      },
    };
  },

  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .cusDiffPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.initDate()
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {
        createUserId: this.$route.query.userId || "",
      };
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    goReturn() {
      this.openSubPage({
        name: "checkData",
        params: {
          active: 'dealerData'
        }
      })
    },
    async Reconciliation(row, type) {
      let text = type === 1 ? "无需处理" : "重新对账";
      let status = await this.$confirm(`是否确认${text}？`, "提示", { type: "warning" });
      if (status !== "confirm") return;
      let interfaceType = type === 1 ? this.$api.dataReport.setCusDiff : this.$api.dataReport.cusAgainReconciliation;
      interfaceType(row.id).then((res) => {
        if (res.success) {
          this.$message.success(`${text}成功`);
        } else {
          this.$message.error(`${text}失败`);
        }
        this.onSearch();
      });
    },
    exportList() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("cusDiffPageList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  mounted() {
    let query = this.$route.query;
    this.searchForm.reconciliationId = query.id || "";
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.date-input
  width 220px !important
.content
  width 100%
  height 100%
  display flex
  justify-content center
  align-items center
  flex-direction column
  .or-code
    width 140px
    height 140px
    margin-top 20px
</style>
